<template>
    <v-app login>
        <v-main class="pa-0">
            <v-container class="fill-height pa-0" fluid>
                <v-card class="elevation-0 fill-height" style="width:100%" fluid>
                    <v-row class="fill-height">
                        <v-col
                            v-if="this.$vuetify.breakpoint.name != 'xs'"
                            cols="12"
                            md="7"
                            class="bkg">
                        </v-col>
                        <v-col v-if="this.$vuetify.breakpoint.name == 'xs'" class="bkg">
                        </v-col>
                        <v-col cols="12" md="5" back align-self="center">
                            <v-card-text justify-center>
                                <v-card max-width="700" align-content-center elevation="0">
                                    <v-row
                                    justify="center"
                                    class="pb-5"
                                    align-content="center">
                                        <v-col
                                            cols="12"
                                            md="5"
                                            v-if="this.$vuetify.breakpoint.name != 'xs'">
                                        <v-img
                                        lazy-src="../../assets/logo.png"
                                        max-height="90%"
                                        max-width="90%"
                                        src="../../assets/logo.png"
                                            ></v-img>
                                        </v-col>
                                        <v-img
                                            align-center
                                            v-if="this.$vuetify.breakpoint.name == 'xs'"
                                            lazy-src="../../assets/logo.png"
                                            max-height="40%"
                                            max-width="40%"
                                            src="../../assets/logo.png"
                                        ></v-img>
                                    </v-row>
                                    <v-form ref="loginForm" @submit="handleLogin()">
                                        <v-row justify="center" align-content="center">
                                            <v-col cols="10" md="8">
                                            <v-text-field
                                                v-model="request.novaSenha"
                                                label="Nova senha"
                                                outlined
                                                @click:append="show = !show"
                                                :type="show ? 'text' : 'password'"
                                                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                                :rules="required"
                                                hide-details=""/>
                                            </v-col>
                                            <v-col cols="10" md="8">
                                            <v-text-field hide-details=""
                                                v-model="request.novaSenhaRepetir"
                                                label="Repetir senha"
                                                outlined
                                                @click:append="show = !show"
                                                :type="show ? 'text' : 'password'"
                                                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                                :rules="[passwordConfirmation]"/>
                                            </v-col>
                                        </v-row>
                                        <v-row justify="center" align-content="center" v-if="showSneakbar">
                                            <v-alert
                                                outlined
                                                :type="colorSnackbar"
                                                text
                                                >
                                                {{ message }}
                                            </v-alert>
                                        </v-row>
                                        <v-row
                                            justify="center"
                                            class="pb-5"
                                            align-content="center"
                                        >
                                            <v-btn
                                            class="px-15"
                                            large
                                            color="indigo darken-3"
                                            rounded
                                            dark
                                            @click="enviar()"
                                            >enviar</v-btn
                                            >
                                        </v-row>
                                    </v-form>
                                </v-card>
                            </v-card-text>
                        </v-col>
                    </v-row>
                </v-card>
            </v-container>
        </v-main>
    </v-app>
</template>
<script>
import { mapActions } from 'vuex';

export default {
    data: () =>({
        show: false,
        showSneakbar: '',
        colorSnackbar: '',
        message: '',
        required: [(v) => !!v || 'Este campo é obrigatório'],
        request:{
            novaSenha: '',
            novaSenhaRepetir: '',
            token: ''
        }
    }),
    computed: {
        passwordConfirmation() {
        return (
          this.request.novaSenha === this.request.novaSenhaRepetir ||
          'As senhas estão diferentes'
        );
      }
    }, 
    methods:{
        ...mapActions('user', ['newPassword']),
        async enviar(){
            this.request.token = this.$route.query.token
            const resp = await this.newPassword(this.request);
            if(resp === 200){
                this.showSneakbar = true;
                this.colorSnackbar = 'success'
                this.message = 'Senha alterada com sucesso. Você será redirecionado para a tela de login.'
                setTimeout( () => this.$router.push({ name: 'login'}), 5000);
            }else{
                this.showSneakbar = true;
                this.colorSnackbar = 'error';
                this.message = "Ocorreu um erro. Contate o administrador.";
                setTimeout( () => this.$router.push({ name: 'login'}), 5000);
            }
            
        }
    }
}
</script>
<style scoped>
  .bkg {
    background-image: url('../../assets/bannerTopo.png');
    background-size: cover;
  }
</style>
